<template>
    <div e-toolbar-items> 
        <div v-if='this.data.result === 0'>
            <div v-on:click="handleClick" id='detail'>{{data.detail}}</div>
        </div>
        <div v-else>
            <span>
                {{data.detail}}
            </span>
        </div>
    </div>
</template>
<script>
export default {
  name: 'detail',
  data() {
    return {
       data: {}, 
    };
  },
  methods:{
    handleClick(args){
        // console.log('taskId', this.data.taskId)
        // console.log('this.data', this.data)
        // console.log('args',args)
        // console.log('this',this)
        // this.$emit('detail', this.data.taskId);
    } 
  }
};
</script>
<style scoped>
#detail {
    color: #4a90e2;
}
</style>>
